(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Etebase", [], factory);
	else if(typeof exports === 'object')
		exports["Etebase"] = factory();
	else
		root["Etebase"] = factory();
})(self, function() {
return 